import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/node_modules/.pnpm/@headlessui+react@2.2.4_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/@headlessui/react/dist/components/button/button.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@headlessui+react@2.2.4_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/@headlessui/react/dist/components/disclosure/disclosure.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.6_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.6_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/shared/components/elements/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TotalWithDiscount"] */ "/vercel/path0/shared/components/price-line.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/shared/components/shop/diamonds/add-diamond.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/shared/components/shop/diamonds/header-list-item.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/hero/diamond_hero.png");
